import React, { useState, useEffect } from "react";
import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from '@mui/material';
import axios from 'axios';
import { getToken } from '../../authetication/loginState';
import Clock from "../../images/video-timer.png";
import DeleteIcon from "../../images/deleteIcon.png";
import NoraUploader from "../../components/NoraUploader";
import InterviewsSwiper from "../../components/InterviewsSwiper";
import Box from '@mui/material/Box';
import Modal from "@material-ui/core/Modal";
import Spinner from "../../components/SectionSpinner/spinner";
import FlashOnIcon from '@mui/icons-material/FlashOn';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReferralRewardsModal from "../../components/ReferralRewardsModal";

const MockInterviewerInput = () => {
    const location = useLocation();
    const isMobile = useMediaQuery('(max-width:600px)');
    const { candidatePosition, candidateJobDescription, candidateCompanyName, candidateResume, candidateResumeFileName, candidateTechnicalLevel, fromFeedback = false } = location.state || {};

    const [position, setPosition] = useState(candidatePosition || "");
    const [jobDescription, setJobDescription] = useState(candidateJobDescription || "");
    const [resume, setResume] = useState(candidateResume || null);
    const [fileName, setFileName] = useState(candidateResumeFileName || "");
    const [companyName, setCompanyName] = useState(candidateCompanyName || "");
    
    // Add new state variables for salary and location
    const [salaryRange, setSalaryRange] = useState("");
    const [currency, setCurrency] = useState("USD");
    const [locationInput, setLocationInput] = useState("");
    
    const [interviews, setInterviews] = useState([]);
    const [interviewsSummary, setInterviewsSummary] = useState(null);
    const storedInterviewsSummary = localStorage.getItem("interviewsSummary");
    const interviewsSummaryFinal = storedInterviewsSummary ? JSON.parse(storedInterviewsSummary) : interviewsSummary;

    const [interviewsNextStepCompany, setInterviewsNextStepCompany] = useState(null);
    const storedInterviewsNextStepCompany = localStorage.getItem("interviewsNextStepCompany");
    const interviewsNextStepCompanyFinal = storedInterviewsNextStepCompany ? JSON.parse(storedInterviewsNextStepCompany) : interviewsNextStepCompany;

    const [interviewsNextStepPosition, setInterviewsNextStepPosition] = useState(null);
    const storedInterviewsNextStepPosition = localStorage.getItem("interviewsNextStepPosition");
    const interviewsNextStepPositionFinal = storedInterviewsNextStepPosition ? JSON.parse(storedInterviewsNextStepPosition) : interviewsNextStepPosition;

    const [technicalLevel, setTechnicalLevel] = useState(candidateTechnicalLevel || 5);
    const [open, setOpen] = useState(false);
    const [openJobDescription, setOpenJobDescription] = useState(false);
    const [openRedoInterview, setOpenRedoInterview] = useState(false);
    const [openCompanySuggestion, setOpenCompanySuggestion] = useState(false);
    const [openPositionSuggestion, setOpenPositionSuggestion] = useState(false);
    const [selectedInterview, setSelectedInterview] = useState(null);
    const [visibleRows, setVisibleRows] = useState(1); 
    const [fromFeedbackState, setFromFeedbackState] = useState(location.state?.fromFeedback || false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const userEmail = localStorage.getItem("userEmail");

    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);
    const [openTest, setOpenTest] = useState(false);
    const [stripeLoaded, setStripeLoaded] = useState(false);
    const [checkout, setCheckout] = useState(null);
    const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
    const [checkoutError, setCheckoutError] = useState('');
    const [selectedPlan, setSelectedPlan] = useState('annual');
    const [paymentProcessing, setPaymentProcessing] = useState(false);
    const [openReferralModal, setOpenReferralModal] = useState(false);

    const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

    const isReferred = localStorage.getItem("userReferred") === "true";

    const style2 = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: isMobile ? "90vw" : "80vw",
        height: isMobile ? "85vh" : "70vh", 
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        borderRadius: "10px",
        textAlign: 'center',
        overflow: "scroll",
        p: 4,
    };

    const handleDeleteInterview = (interviewId) => {
        // Add confirmation dialog
        if (window.confirm('Are you sure you want to delete this interview? This action cannot be undone.')) {
            // Make API call to delete the interview
            deleteInterview(interviewId);
        }
    };

    const deleteInterview = async (interviewId) => {
        try {
            setIsLoading(true);
            await axios.delete(
                `${process.env.REACT_APP_API_ENDPOINT}/Chat/deleteInterview/${interviewId}`, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`,
                    },
                }
            );
            
            // Remove the interview from the local state
            setInterviews(prevInterviews => 
                prevInterviews.filter(interview => interview.interviewId !== interviewId)
            );
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error('Error deleting interview:', error);
            alert('Failed to delete interview. Please try again.');
        }
    };

    let navigate = useNavigate();

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        ...(isMobile ? {} : { width: "70vw" }),
        height: isMobile ? "90vh" : "80vh",
        transform: 'translate(-50%, -50%)',
        bgcolor: '#fafafa',
        boxShadow: 24,
        textAlign: 'center',
        overflow: "scroll",
        p: 4,
    };

    useEffect(() => {
        if (!getToken()) {
            localStorage.clear();
            navigate("/login");
            return;
        }

        const slider = document.querySelector('.custom-slider');
        if (slider) {
            slider.style.background = `linear-gradient(to right, #56C385 0%, #56C385 ${technicalLevel * 10}%, #fff ${technicalLevel * 10}%, #fff 100%)`;
        }

        const fetchInterviews = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_API_ENDPOINT}/Chat/getInterviews`, 
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'text/plain',
                            Authorization: `Bearer ${getToken()}`,
                        },
                    }
                );
                setInterviews(response.data);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error('Error fetching interviews:', error);
            }
        };

        const fetchInterviewsSummary = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_ENDPOINT}/Chat/getInterviewsSummary`, 
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'text/plain',
                            Authorization: `Bearer ${getToken()}`,
                        },
                    }
                );
                setInterviewsSummary(response.data.overallSummary);
                localStorage.setItem("lastSummaryFetch", Date.now()); 
                localStorage.setItem("interviewsSummary", JSON.stringify(response.data.overallSummary)); 
            } catch (error) {
                console.error('Error fetching interviews summary:', error);
            }
        };

        const fetchInterviewsNextStepCompany = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_ENDPOINT}/Chat/getInterviewsNextStepsCompany`, 
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'text/plain',
                            Authorization: `Bearer ${getToken()}`,
                        },
                    }
                );
                setInterviewsNextStepCompany(response.data);
                localStorage.setItem("interviewsNextStepCompany", JSON.stringify(response.data)); 
            } catch (error) {
                console.error('Error fetching interviews next step company:', error);
            }
        };

        const fetchInterviewsNextStepPosition = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_ENDPOINT}/Chat/getInterviewsNextStepsPosition`, 
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'text/plain',
                            Authorization: `Bearer ${getToken()}`,
                        },
                    }
                );
                setInterviewsNextStepPosition(response.data);
                localStorage.setItem("interviewsNextStepPosition", JSON.stringify(response.data)); 
            } catch (error) {
                console.error('Error fetching interviews next step position:', error);
            }
        };

        const lastFetchTime = parseInt(localStorage.getItem("lastSummaryFetch")) || 0;
        const currentTime = Date.now();
        const twoHours = 7200000;

        if (firstLoad || currentTime - lastFetchTime >= twoHours) {
            fetchInterviewsSummary();
            fetchInterviewsNextStepCompany();
            fetchInterviewsNextStepPosition();
            setFirstLoad(false);
        }

        fetchInterviews();
        const interval = setInterval(fetchInterviewsSummary, twoHours);

        return () => clearInterval(interval);
    }, [firstLoad, navigate, technicalLevel]);

    useEffect(() => {
        const checkSubscriptionLoop = async () => {
            try {
                const userEmail = localStorage.getItem('userEmail') || localStorage.getItem('email');
                if (!userEmail) {
                    setIsCheckingSubscription(false);
                    return;
                }

                const subscriptionCheck = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/checkSubscription`, {
                    email: userEmail,
                }, {
                    headers: {
                        'Content-Type': 'application/json', 
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`,
                    },
                });

                if (subscriptionCheck.data.desiredRole) {
                    localStorage.setItem("desiredRole", subscriptionCheck.data.desiredRole);
                }

                if (subscriptionCheck.data.isSubscribed) {
                    setIsSubscribed(true);
                    setIsCheckingSubscription(false);
                    setOpenTest(false);
                } else {
                    setIsSubscribed(false);
                    setIsCheckingSubscription(false);
                }
            } catch (error) {
                console.error('Error checking subscription:', error);
                setIsCheckingSubscription(false);
            }
        };

        checkSubscriptionLoop();
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.async = true;
        script.onload = () => {
            if (window.Stripe) {
                setStripeLoaded(true);
            }
        };
        script.onerror = () => {
            console.error('Failed to load Stripe.js');
            setCheckoutError('Failed to load payment system. Please refresh the page.');
        };
        document.head.appendChild(script);

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, []);

    useEffect(() => {
        return () => {
            if (checkout) {
                try {
                    checkout.destroy();
                } catch (error) {
                    console.warn('Error destroying checkout on cleanup:', error);
                }
            }
        };
    }, [checkout]);

    const initializeEmbeddedCheckout = async (plan) => {
        if (!stripeLoaded || !window.Stripe) {
            console.error('Stripe not loaded yet');
            setCheckoutError('Stripe is still loading. Please try again in a moment.');
            return;
        }
        if (!stripePublishableKey) {
            console.error('Missing publishable Stripe key');
            setCheckoutError('Payment configuration is incomplete. Please contact support.');
            return;
        }

        try {
            setCheckoutError('');
            setIsCheckoutLoading(true);

            const userEmail = localStorage.getItem('userEmail') || localStorage.getItem('email');
            if (!userEmail) throw new Error('Missing user email for checkout session.');

            const stripe = window.Stripe(stripePublishableKey);

            const fetchClientSecret = async () => {
                const priceId = plan === 'annual'
                    ? ('price_1S8GAZ007XiUv8ECfnqj7tsI')
                    : ('price_1PtG3P007XiUv8ECG0fSdL6h');

                const payload = { 
                    email: userEmail, 
                    priceId,
                    returnUrl: window.location.href
                };
                
                const response = await fetch(
                    `${process.env.REACT_APP_API_ENDPOINT}/payments/create-embedded-checkout-session`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${getToken()}`,
                        },
                        body: JSON.stringify(payload),
                    }
                );
                
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
                }
                
                const responseData = await response.json();
                const { clientSecret } = responseData;
                
                if (!clientSecret) {
                    throw new Error('No clientSecret received from backend');
                }
                
                return clientSecret;
            };

            const embeddedCheckout = await stripe.initEmbeddedCheckout({ 
                fetchClientSecret,
                onComplete: () => {
                    setTimeout(() => {
                        checkSubscriptionAfterPayment();
                    }, 2000);
                }
            });
            embeddedCheckout.mount('#checkout');
            setCheckout(embeddedCheckout);
        } catch (error) {
            console.error('Error initializing embedded checkout:', error);
            setCheckoutError('We could not start the payment flow. Please try again or contact support.');
        } finally {
            setIsCheckoutLoading(false);
        }
    };

    const handleUpgrade = async (plan) => {
        if (checkout) {
            try {
                checkout.destroy();
            } catch (error) {
                console.warn('Error destroying previous checkout:', error);
            }
            setCheckout(null);
        }
        
        const checkoutContainer = document.getElementById('checkout');
        if (checkoutContainer) {
            checkoutContainer.innerHTML = '';
        }
        
        setSelectedPlan(plan);
        
        await new Promise(resolve => setTimeout(resolve, 200));
        await initializeEmbeddedCheckout(plan);
    };

    const checkSubscriptionAfterPayment = async (maxRetries = 20, currentRetry = 0) => {
        try {
            if (currentRetry === 0) {
                setPaymentProcessing(true);
                setCheckoutError('');
            }

            const userEmail = localStorage.getItem('userEmail') || localStorage.getItem('email');
            if (!userEmail) {
                setPaymentProcessing(false);
                return;
            }

            const subscriptionCheck = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/checkSubscription`, {
                email: userEmail,
            }, {
                headers: {
                    'Content-Type': 'application/json', 
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`,
                },
            });

            if (subscriptionCheck.data.isSubscribed) {
                setIsSubscribed(true);
                setOpenTest(false);
                setCheckoutError('');
                setPaymentProcessing(false);
                console.log('Subscription activated successfully!');
            } else if (currentRetry < maxRetries) {
                setTimeout(() => checkSubscriptionAfterPayment(maxRetries, currentRetry + 1), 3000);
            } else {
                setCheckoutError('');
            }
        } catch (error) {
            console.error('Error checking subscription after payment:', error);
            if (currentRetry < maxRetries) {
                setTimeout(() => checkSubscriptionAfterPayment(maxRetries, currentRetry + 1), 5000);
            } else {
                setCheckoutError('Unable to verify payment status. Please refresh the page or contact support.');
            }
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        setResume(e.target.value);

        reader.onload = function(event) {
            localStorage.setItem("resume", event.target.result);
            setResume(event.target.result);  // Set the resume state to the file's content
        };

        reader.readAsDataURL(file);
        setFileName(file ? file.name : "");  // Update the fileName state
        localStorage.setItem("resumeFileName", file.name);

    };

    const handleTechnicalLevelChange = (e) => {
        var value = e.target.value
        setTechnicalLevel(value);
        e.target.style.background = `linear-gradient(to right, #56C385 0%, #56C385 ${value * 10}%, #fff ${value * 10}%, #fff 100%)`;
    };

    const handleGetStarted = () => {
        localStorage.setItem("companyName", companyName);
        localStorage.setItem("position", position);
        localStorage.setItem("jobDescription", jobDescription);
        localStorage.setItem("technicalLevel", technicalLevel);
        
        // Store salary and location data when in salary negotiation mode
        if (technicalLevel === 15) {
            localStorage.setItem("salaryRange", salaryRange);
            localStorage.setItem("currency", currency);
            localStorage.setItem("location", locationInput);
        }
        
        navigate("/mockInterviewerZoom");
    };

    const triggerFileInput = () => {
        document.getElementById('fileInput').click();
    };

    const formatTime = (dateStr) => {
        const date = new Date(dateStr);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        return formattedDate;
    };

    const handleViewFeedback = (interview) => {
        navigate("/mockInterviewerFeedback", { state: { 
            aiResponse: interview.feedback, 
            history: interview.history, 
            timerFeedback: interview.interviewTime, 
            technicalLevel: interview.technicalLevel || 5, 
            fromInputScreen: true,
            audioRecordingUrl: interview.audioRecordingUrl  
        }});
    };

    const handleInterviewRedoCompany = (companyName, jobDescription, position) => {
        // Check subscription before opening modal
        if (!isSubscribed && interviews.length >= 1) {
            setOpenTest(true);
            return;
        }

        setOpen(true);
        setCompanyName(companyName);
        setPosition(position);
        setJobDescription(jobDescription);
        return (
            <Modal onClose={() => setOpen(false)} open={open || fromFeedbackState}>
                    <Box sx={style}>
                        <button className="close-button" onClick={() => { setOpen(false); setFromFeedbackState(false); }}>X</button>
                            <NoraUploader
                                position={position}
                                setPosition={setPosition}
                                companyName={companyName}
                                setCompanyName={setCompanyName}
                                jobDescription={jobDescription}
                                setJobDescription={setJobDescription}
                                technicalLevel={technicalLevel}
                                setTechnicalLevel={setTechnicalLevel}
                                handleFileChange={handleFileChange}
                                triggerFileInput={triggerFileInput}
                                handleTechnicalLevelChange={handleTechnicalLevelChange}
                                fileName={fileName}
                                setFileName={setFileName} 
                                resume={resume}
                                setResume={setResume}
                                handleGetStarted={handleGetStarted}
                                isFormComplete={isFormComplete}
                                isModal={true}
                                salaryRange={salaryRange}
                                setSalaryRange={setSalaryRange}
                                currency={currency}
                                setCurrency={setCurrency}
                                location={locationInput}
                                setLocation={setLocationInput}
                            />
                    </Box>
            </Modal>
        )
    };

    const handleInterviewRedoPosition = (companyName, jobDescription, position) => {
        // Check subscription before opening modal
        if (!isSubscribed && interviews.length >= 1) {
            setOpenTest(true);
            return;
        }

        setOpen(true);
        setCompanyName(companyName);
        setPosition(position);
        setJobDescription(jobDescription);
        return (
            <Modal onClose={() => setOpen(false)} open={open || fromFeedbackState}>
                    <Box sx={style}>
                        <button className="close-button" onClick={() => { setOpen(false); setFromFeedbackState(false); }}>X</button>
                            <NoraUploader
                                position={position}
                                setPosition={setPosition}
                                companyName={companyName}
                                setCompanyName={setCompanyName}
                                jobDescription={jobDescription}
                                setJobDescription={setJobDescription}
                                technicalLevel={technicalLevel}
                                setTechnicalLevel={setTechnicalLevel}
                                handleFileChange={handleFileChange}
                                triggerFileInput={triggerFileInput}
                                handleTechnicalLevelChange={handleTechnicalLevelChange}
                                fileName={fileName}
                                setFileName={setFileName} 
                                resume={resume}
                                setResume={setResume}
                                handleGetStarted={handleGetStarted}
                                isFormComplete={isFormComplete}
                                isModal={true}
                                salaryRange={salaryRange}
                                setSalaryRange={setSalaryRange}
                                currency={currency}
                                setCurrency={setCurrency}
                                location={locationInput}
                                setLocation={setLocationInput}
                            />
                    </Box>
            </Modal>
        )
    };

    const handleInterviewRedo = (companyName, jobDescription, position) => {
        // Check subscription before opening modal
        if (!isSubscribed && interviews.length >= 1) {
            setOpenTest(true);
            return;
        }

        setOpen(true);
        setCompanyName(companyName);
        setPosition(position);
        setJobDescription(jobDescription);
        return (
            <Modal onClose={() => setOpen(false)} open={open || fromFeedbackState}>
                    <Box sx={style}>
                        <button className="close-button" onClick={() => { setOpen(false); setFromFeedbackState(false); }}>X</button>
                            <NoraUploader
                                position={position}
                                setPosition={setPosition}
                                companyName={companyName}
                                setCompanyName={setCompanyName}
                                jobDescription={jobDescription}
                                setJobDescription={setJobDescription}
                                technicalLevel={technicalLevel}
                                setTechnicalLevel={setTechnicalLevel}
                                handleFileChange={handleFileChange}
                                triggerFileInput={triggerFileInput}
                                handleTechnicalLevelChange={handleTechnicalLevelChange}
                                fileName={fileName}
                                setFileName={setFileName} 
                                resume={resume}
                                setResume={setResume}
                                handleGetStarted={handleGetStarted}
                                isFormComplete={isFormComplete}
                                isModal={true}
                                salaryRange={salaryRange}
                                setSalaryRange={setSalaryRange}
                                currency={currency}
                                setCurrency={setCurrency}
                                location={locationInput}
                                setLocation={setLocationInput}
                            />
                    </Box>
            </Modal>
        )

    };

    const loadMore = () => {
        setVisibleRows(prevRows => prevRows + 1);
    }

    const getVisibleInterviews = (rowIndex) => {
        const start = rowIndex * 3;
        return interviews
          .sort((a, b) => new Date(b.creationTimeStamp) - new Date(a.creationTimeStamp))
          .slice(start, start + 3);
      };

    const isFormComplete = position && companyName;

    return (
        <div className="mockInterviewerInput-page">
            {isLoading ? (
                <div className="w-full h-screen px-40 mobile-padding">
                    <Spinner />
                </div>
            ) : (
            interviews && interviews.length > 0 ? (
                <>
                    <div className="main-container">
                        { !isMobile && (
                        <div className="side-menu-nora menu-add">
                            <ul>
                                <li onClick={() => document.getElementById("start").scrollIntoView({ behavior: 'smooth' })}>Start Interview</li>
                                <li onClick={() => document.getElementById("interviews").scrollIntoView({ behavior: 'smooth' })}>Your Interviews</li>
                                <li onClick={() => document.getElementById("progress").scrollIntoView({ behavior: 'smooth' })}>Your Progress</li>
                                <li onClick={() => document.getElementById("nextsteps").scrollIntoView({ behavior: 'smooth' })}>Next Steps</li>
                                <li className="referral-side-link" onClick={() => setOpenReferralModal(true)}>Referral</li>
                                <li onClick={() => navigate("/profile")}>Profile</li>
                            </ul>
                        </div> )}
                        
                        <div className="main-content">
                        <div className="section-title-input-2">Welcome Back, {JSON.parse(interviews[0].feedback)["candidate"]}! </div>

                        <div className="section-subtitle-input" id="start">Start New Interview </div>

                        <div className="interview-screen">
                            <h2>Big interview coming up? </h2>
                            <h2> Need to get some practice in?</h2>
                            <br /> <br />
                            <button className="nora-button-style" onClick={() => { 
                                if (!isSubscribed && interviews.length >= 1) {
                                    setOpenTest(true);
                                } else {
                                    setOpen(true);
                                }
                            }}>Start New Interview</button>
                            <Modal onClose={() => setOpen(false)} open={open || fromFeedbackState}>
                                <Box sx={style}>
                                <button className="close-button" onClick={() => { setOpen(false); setFromFeedbackState(false); setCompanyName(""); setPosition(""); setJobDescription("")}}>X</button>
                                    <NoraUploader
                                        position={position}
                                        setPosition={setPosition}
                                        companyName={companyName}
                                        setCompanyName={setCompanyName}
                                        jobDescription={jobDescription}
                                        setJobDescription={setJobDescription}
                                        technicalLevel={technicalLevel}
                                        setTechnicalLevel={setTechnicalLevel}
                                        handleFileChange={handleFileChange}
                                        triggerFileInput={triggerFileInput}
                                        handleTechnicalLevelChange={handleTechnicalLevelChange}
                                        fileName={fileName}
                                        setFileName={setFileName} 
                                        resume={resume}
                                        setResume={setResume}
                                        handleGetStarted={handleGetStarted}
                                        isFormComplete={isFormComplete}
                                        isModal={true}
                                        salaryRange={salaryRange}
                                        setSalaryRange={setSalaryRange}
                                        currency={currency}
                                        setCurrency={setCurrency}
                                        location={locationInput}
                                        setLocation={setLocationInput}
                                    />
                                </Box>
                            </Modal>
                        </div>
                        
                        <div className="section-subtitle-input margin-top-sections" id="interviews">Your Completed Interviews</div>
                        { !isMobile ? ( <div>{Array.from({ length: visibleRows }).map((_, rowIndex) => (
                        <div className="completed-interviews">
                            {getVisibleInterviews(rowIndex)
                                .map((interview, index) => (
                                    <div className="interview-card" key={interview.interviewId || index}>
                                        {isSubscribed && (
                                            <button 
                                                className="delete-interview-button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDeleteInterview(interview.interviewId);
                                                }}
                                                title="Delete Interview"
                                            >
                                                <img src={DeleteIcon} alt="Delete" className="delete-icon" />
                                            </button>
                                        )}
                                        <div key={index} className="interview-card-info"> {interview.position} </div> 
                                        <div className="interview-card-info">{interview.companyName}</div> <br/>
                                        <div className="interview-clock-styling">{formatTime(interview.creationTimeStamp)}</div>
                                        {interview.interviewTime && (
                                            <div>
                                                <img src={Clock} className="interview-clock-text-styling" /> 
                                                {interview.interviewTime}
                                            </div>
                                        )}                                        
                                        <br /> <br/>
                                        <button className="inputButton-1" onClick={() => handleViewFeedback(interview)}> View Feedback Report </button>
                                        <br /> <br />
                                        {interview.jobDescription && interview.jobDescription !== "No Job Description Provided" && (
                                            <button className="inputButton-2" 
                                                onClick={() => {
                                                    setSelectedInterview(interview);
                                                    setOpenJobDescription(true);
                                                }}>
                                                View Job Description
                                            </button>
                                        )}

                                        <Modal onClose={() => setOpenJobDescription(false)} open={openJobDescription}>
                                            <Box sx={style}>
                                                <button className="close-button" onClick={() => setOpenJobDescription(false)}>X</button>
                                                {selectedInterview && (
                                                <>
                                                    <h4 className="interview-modal-position">{selectedInterview.position} @ {selectedInterview.companyName}</h4>
                                                    <h4 className="interview-modal-jd">Job Description: </h4>
                                                    <div className="interview-modal-jd-text">
                                                        {selectedInterview.jobDescription.split('\n').map((line, index) => (
                                                            <h4 key={index}>{line}</h4>
                                                        ))}
                                                    </div>                                                
                                                </>
                                                )}
                                            </Box>
                                        </Modal>
                                    </div> 
                                ))} 
                                
                        </div>))}
                        {visibleRows * 3 < interviews.length && (<div className="see-more" onClick={loadMore}><u>See More</u></div> )}    
                        {visibleRows > 1 && (<div className="see-more" onClick={()=>setVisibleRows(1)}><u>See Less</u></div>)}
                           </div>  ) : (<InterviewsSwiper interviews={interviews} isSubscribed={isSubscribed} 
                           formatTime={formatTime} handleViewFeedback={handleViewFeedback}
                           setSelectedInterview={setSelectedInterview} setOpenJobDescription={setOpenJobDescription}
                           selectedInterview={selectedInterview} openJobDescription={openJobDescription} handleDeleteInterview={handleDeleteInterview} />)}
                        <div className="section-subtitle-input  margin-top-sections" id="progress">Your Interview Progress</div>
                        {interviewsSummaryFinal && (
                            <div className="interview-summary">
                                <h4 className="summary-heading">Overall Summary</h4>
                                <p className="summary-caption">{interviewsSummaryFinal?.overall_summary}</p>

                                <h4 className="summary-heading-2">Technical Skill Improvement</h4>
                                <p className="summary-caption">{interviewsSummaryFinal?.overall_technical_skills}</p>

                                <h4 className="summary-heading-2">Soft Skill Improvement</h4>
                                <p className="summary-caption">{interviewsSummaryFinal?.overall_soft_skills}</p>
                            </div>
                        )}

                        <br /> <br />
                        <div className="section-subtitle-input" id="nextsteps">Next Steps For You</div>
                            <div className="next-steps">
                            <div className="interview-card-info">Repeat one of your last interviews: </div>
                            {interviews
                                .sort((a, b) => new Date(b.creationTimeStamp) - new Date(a.creationTimeStamp))
                                .map((interview, index) => (
                                <>
                                    <li key={index} className="bullet-points-left-margin">
                                        <button className="link-button" onClick={() => {
                                            setSelectedInterview(interview);
                                            setOpenRedoInterview(true);
                                        }}>
                                            {interview?.position} @ {interview?.companyName}
                                        </button>

                                        <Modal onClose={() => setOpenRedoInterview(false)} open={openRedoInterview}>
                                            <Box sx={style}>
                                                <button className="close-button" onClick={() => setOpenRedoInterview(false)}>X</button>
                                                {selectedInterview && (
                                                <>
                                                    <h4 className="interview-modal-position">{selectedInterview.position} @ {selectedInterview.companyName}</h4>
                                                    <h4 className="interview-modal-jd">Job Description: </h4>
                                                    <div className="interview-modal-jd-text">
                                                        {selectedInterview.jobDescription.split('\n').map((line, index) => (
                                                            <h4 key={index}>{line}</h4>
                                                        ))}
                                                    </div>

                                                    <button className="inputButton-1" onClick={() => handleInterviewRedo(selectedInterview.companyName, 
                                                        selectedInterview?.jobDescription,
                                                        selectedInterview?.position)}>
                                                        Redo Interview
                                                    </button>
                                                </>
                                                )}
                                            </Box>
                                        </Modal>
                                    </li>
                                </>
                            ))} 

                            {interviewsNextStepCompanyFinal && (
                                <><div className="section-suggestion">Here is a company interview suggestion for you: </div>
                                <li className="bullet-points-left-margin">
                                <button className="link-button" onClick={() => {setOpenCompanySuggestion(true)}}>
                                {interviewsNextStepCompanyFinal?.nextStepCompany?.position} @
                                        {interviewsNextStepCompanyFinal?.nextStepCompany?.company}
                                    </button>

                                    <Modal onClose={() => setOpenCompanySuggestion(false)} open={openCompanySuggestion}>
                                        <Box sx={style}>
                                            <button className="close-button" onClick={() => setOpenCompanySuggestion(false)}>X</button>
                                            <h4 className="interview-modal-position">{interviewsNextStepCompanyFinal?.nextStepCompany?.position}
                                                @ {interviewsNextStepCompanyFinal?.nextStepCompany?.company}</h4>
                                            <h4 className="interview-modal-jd">Job Description: </h4>
                                            <div className="interview-modal-jd-text">
                                                    {interviewsNextStepCompanyFinal?.nextStepCompany?.job_description.split('\n').map((line, index) => (
                                                        <h4 key={index}>{line}</h4>
                                                    ))}
                                            </div>

                                            <button className="inputButton-1" onClick={() => handleInterviewRedoCompany(interviewsNextStepCompanyFinal?.nextStepCompany?.company,
                                                interviewsNextStepCompanyFinal?.nextStepCompany?.job_description,
                                                interviewsNextStepCompanyFinal?.nextStepCompany?.position)}>
                                                Start Interview
                                            </button>
                                        </Box>
                                    </Modal>
                                </li></>
                            )}

                            {interviewsNextStepPositionFinal && interviewsNextStepPositionFinal?.nextStepPosition?.position && (
                                <><div className="section-suggestion">Check out this position interview suggestion: </div>
                                <li className="bullet-points-left-margin">
                                    <button className="link-button" onClick={() => {setOpenPositionSuggestion(true)}}>
                                    {interviewsNextStepPositionFinal?.nextStepPosition?.position} @
                                        {interviewsNextStepPositionFinal?.nextStepPosition?.company}
                                    </button>

                                    <Modal onClose={() => setOpenPositionSuggestion(false)} open={openPositionSuggestion}>
                                        <Box sx={style}>
                                            <button className="close-button" onClick={() => setOpenPositionSuggestion(false)}>X</button>
                                            <h4 className="interview-modal-position">{interviewsNextStepPositionFinal?.nextStepPosition?.position}
                                                @ {interviewsNextStepPositionFinal?.nextStepPosition?.company}</h4>
                                            <h4 className="interview-modal-jd">Job Description: </h4>
                                            <div className="interview-modal-jd-text">
                                                    {interviewsNextStepPositionFinal?.nextStepPosition?.job_description.split('\n').map((line, index) => (
                                                        <h4 key={index}>{line}</h4>
                                                    ))}
                                            </div>

                                            <button className="inputButton-1" onClick={() => handleInterviewRedoPosition(interviewsNextStepPositionFinal?.nextStepPosition?.company,
                                                interviewsNextStepPositionFinal?.nextStepPosition?.job_description,
                                                interviewsNextStepPositionFinal?.nextStepPosition?.position)}>
                                                Start Interview
                                            </button>
                                        </Box>
                                    </Modal>
                                </li></>
                            )}
                            </div>
                            </div>
                    </div>
                </>
            ) : (
                <NoraUploader
                    position={position}
                    setPosition={setPosition}
                    companyName={companyName}
                    setCompanyName={setCompanyName}
                    jobDescription={jobDescription}
                    setJobDescription={setJobDescription}
                    technicalLevel={technicalLevel}
                    setTechnicalLevel={setTechnicalLevel}
                    handleFileChange={handleFileChange}
                    triggerFileInput={triggerFileInput}
                    handleTechnicalLevelChange={handleTechnicalLevelChange}
                    fileName={fileName}
                    setFileName={setFileName} 
                    resume={resume}
                    setResume={setResume}
                    handleGetStarted={handleGetStarted}
                    isFormComplete={isFormComplete}
                    isModal={false}
                    salaryRange={salaryRange}
                    setSalaryRange={setSalaryRange}
                    currency={currency}
                    setCurrency={setCurrency}
                    location={locationInput}
                    setLocation={setLocationInput}
                />
            )
        )}    

        <ReferralRewardsModal
            open={openReferralModal}
            onClose={() => setOpenReferralModal(false)}
        />

        {/* Payment Modal */}
        <Modal onClose={() => setOpenTest(false)} open={openTest} disableBackdropClick={true} disableEscapeKeyDown={true}>
            <Box className="custom-modal-box" sx={style2}>
                <button 
                    onClick={() => setOpenTest(false)}
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#666',
                        zIndex: 1000,
                        padding: '5px',
                        borderRadius: '50%',
                        width: '35px',
                        height: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    aria-label="Close modal"
                >
                    ✕
                </button>
                
                <h2 className="pricing-title">Unlock feedback & unlimited interviews</h2>
                <p className="pricing-subtitle">
                    <span className="pricing-subtext">Subscribe and unlock all your interview insights with Nora</span>
                </p>

                {checkout && (
                    <button 
                        className="pricing-back-btn" 
                        onClick={() => {
                            if (checkout) {
                                checkout.destroy();
                                setCheckout(null);
                                setCheckoutError('');
                            }
                        }}
                        aria-label="Go back to plan selection"
                    >
                        ← Back to Plans
                    </button>
                )}

                {!checkout && (
                    <div className="pricing-grid">
                        <div className={`pricing-card ${selectedPlan === 'monthly' ? 'featured' : ''}`}>
                            <div className="pricing-card__icon"><AutoFixHighIcon /></div>
                            <div className="pricing-card__name">Actually Get Better</div>
                            <div className="pricing-card__separator"></div>
                            <div className="pricing-card__price">
                                <span className="pricing-amount">$15</span>
                                <span className="pricing-period">/mo</span>
                            </div>
                            <div className="pricing-card__desc">Best for consistent practice & growth.</div>
                            <ul className="pricing-list">
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Unlimited mock interviews</li>
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Complete Nora feedback</li>
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Interactive AI coaching chat</li>
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Detailed question analysis</li>
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Personalised action plan</li>
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Cancel your subscription anytime</li>
                            </ul>
                            <button
                                className="pricing-btn solid pricing-btn--monthly"
                                onClick={() => handleUpgrade('monthly')}
                                disabled={isCheckoutLoading}
                            >
                                {isCheckoutLoading && selectedPlan === 'monthly' ? 'Starting…' : 'Upgrade Now'}
                            </button>
                        </div>

                        <div className={`pricing-card ${selectedPlan === 'annual' ? 'featured' : ''}`}>
                            <div className="pricing-card__top-line">
                                <div className="pricing-card__icon"><FlashOnIcon /></div>
                                <div className="pricing-reco-badge">Recommended</div>
                            </div>
                            <div className="pricing-card__name">Best Value</div>
                            <div className="pricing-card__separator"></div>
                            <div className="pricing-card__price">
                                <span className="pricing-amount">$99</span>
                                <span className="pricing-period">/yr</span>                            
                            </div>
                            <div className="pricing-card__desc">Everything you need to level up, at the best price.</div>
                            <ul className="pricing-list">
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Everything in Pro Monthly</li>
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>{"Save over $80/year"}</li>
                                <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Stay motivated with long-term growth</li>
                            </ul>
                            <button
                                className="pricing-btn solid pricing-btn--annual"
                                onClick={() => handleUpgrade('annual')}
                                disabled={isCheckoutLoading}
                            >
                                {isCheckoutLoading && selectedPlan === 'annual' ? 'Starting…' : 'Upgrade Now'}
                            </button>
                        </div>
                    </div>
                )}

                <div
                    id="checkout"
                    style={{
                        display: checkout ? 'block' : 'none',
                        minHeight: checkout ? 500 : 0,
                        width: '100%',
                        marginTop: checkout ? 16 : 0
                    }}
                />

                {checkoutError && (
                    <div className="pricing-error">{checkoutError}</div>
                )}
            </Box>  
        </Modal>
        </div>
    );
};

export default MockInterviewerInput;
